var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M25 0c13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25 11.193 0 25 0zm6.567 14.175c-3.392 0-6.143 2.764-6.143 6.17 0 .485.054.956.16 1.408-5.106-.258-9.634-2.714-12.663-6.448a6.171 6.171 0 00-.832 3.102 6.176 6.176 0 002.734 5.137 6.078 6.078 0 01-2.782-.772l-.001.079a6.166 6.166 0 004.928 6.05 6.143 6.143 0 01-2.774.106c.782 2.452 3.05 4.236 5.738 4.286a12.282 12.282 0 01-7.63 2.642c-.495 0-.984-.028-1.465-.086a17.33 17.33 0 009.417 2.773c11.299 0 17.478-9.405 17.478-17.56 0-.267-.006-.533-.018-.798 1.2-.87 2.242-1.958 3.065-3.195-1.1.491-2.286.822-3.528.971a6.19 6.19 0 002.701-3.413 12.299 12.299 0 01-3.9 1.498 6.124 6.124 0 00-4.485-1.95z"}));
}

TwitterInline.defaultProps = {"width":"50","height":"50"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
